import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class BigMushroom4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.BIG_MUSHROOM4;
}

export default BigMushroom4PoiTileEntity;
